import css from 'styled-jsx/css'

export default function ProductItemLoad() {
  return (
    <div className="product-card">
      <style jsx global>
        {globalStyle}
      </style>
      <div className="info">
        <div className="thumbnail skeleton"></div>
        <div className="sale-info">
          <div className="price skeleton"></div>
          <div className="title--1 skeleton"></div>
          <div className="title--2 skeleton"></div>
          <div className="rating skeleton"></div>
        </div>
      </div>
    </div>
  )
}

const globalStyle = css.global`
  .product-card {
    display: block;

    .info {
      padding: 24px 0px;
      border-bottom: 1px solid var(--indigo-4);

      display: flex;
      .thumbnail {
        margin-right: 12px;
        min-width: 170px;
        height: 170px;
      }

      .sale-info {
        flex-direction: column;
        width: 100%;
        .title {
          &--1 {
            margin-bottom: 4px;
            height: 20px;
            width: 100%;
          }
          &--2 {
            margin-bottom: 16px;
            height: 20px;
            width: 60%;
          }
        }
        .price {
          height: 32px;
          width: 80%;
          max-width: 150px;
          margin-bottom: 8px;
        }
        .rating {
          height: 24px;
          width: 80%;
          max-width: 120px;
        }
      }
    }
  }

  @media screen and (min-width: 768px) {
    .product-card {
      .info {
        padding: 0px 0px;
        border: none;
        display: block;

        .thumbnail {
          margin: 0px;
          height: 100%;
          padding-top: 100%;
        }

        .sale-info {
          margin-top: 16px;

          .title {
            &--1 {
              margin-bottom: 4px;
              height: 22px;
            }
            &--2 {
              margin-bottom: 8px;
              height: 22px;
            }
          }
          .price {
            height: 36px;
          }
        }
      }
    }
  }
`
